import { FC } from 'react';
import { useRecoilState } from 'recoil';
import myInfoState from '../../../atoms/myinfo';
import roomDetailState from '../../../atoms/roomDetail';
import { SystemMessageType, UserDetail } from '../../../connector/type';
import './SystemMessage.scoped.scss'
import inchatNoticeContentsState from '../../../atoms/inchatNoticeContents';

interface SystemMessageProps {
  userId: string;
  userDetail: UserDetail | undefined;
  contents: { 
    systemMessageType: SystemMessageType;
    receiverName?: string;
    quantity?: number;
    fullRound?: string;
    pick?: string;
    ownerName?: string;
    roomId?: string;
    roomName?: string;
    isPremium?: boolean;
    isSecret?: boolean;
  };
}

const SystemMessage: FC<SystemMessageProps> = ({ userId, userDetail, contents }) => {
  const [inchatNoticeContents] = useRecoilState(inchatNoticeContentsState);
  const [myInfo] = useRecoilState(myInfoState);
  const [roomDetil] = useRecoilState(roomDetailState);

  let backgroundColor;
  let preparedCode = <></>;
  let code = <></>;

  if (contents.systemMessageType === SystemMessageType.CREATE_ROOM) {
    code = (
      <div>
        <b style={{ color: '#fff4d3' }}>{contents.ownerName}</b>님이&nbsp;
        { contents.isPremium ? '프리미엄' : '일반' } 채팅방&nbsp;
        <b style={{ color: '#fff4d3' }}>{contents.roomName}</b>을 개설하였습니다.&nbsp;
        <button
          style={{
            color: '#fff4d3',
            padding: 0,
            fontSize: '11px',
          }}
          onClick={() => {
            if (contents.isSecret) {
              window.alert('비밀방은 채팅 대기실을 통해 입장해주세요.');
            } else {
              if (myInfo.userDetail?.id == null || myInfo.userDetail?.id === '') {
                window.alert('로그인 후 이용해주세요.');
              } else {
                window.open(
                  `/chatting-app/room/${contents.roomId}`, 
                  'Room', 
                  'width=940px,height=640px,status=no,scrollbars=no,toolbar=no'
                );
              }
            }
          }}
        >
          [입장하기]
        </button>
      </div>
    );
  } else if (contents.systemMessageType === SystemMessageType.CLEAN_ROOM) {
    code = (<>관리자에 의해 채팅방이 초기화되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.JOIN_USER) {
    code = (<>{userDetail?.nickname}님이 채팅방에 참여하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.GIFT_BULLET) {
    if (roomDetil.id !== 'square') {
      if (contents.quantity == null) {
        return (<></>);
      }
      if (contents.quantity >= 100) {
        preparedCode = (
          <div style={{ textAlign: 'center' }}>
            <img src="/img/item/item_bullet_package.png" alt="a little cashs" style={{ height: '80px' }} />
          </div>
        );
      } else {
        preparedCode = (
          <div style={{ textAlign: 'center' }}>
            <img src="/img/item/item_bullet10.png" alt="a little cashs" style={{ height: '80px' }} />
          </div>
        );
      }
    }
    code = (<>{userDetail?.nickname}님이 {contents.receiverName}님에게 보석 {contents.quantity}개를 선물하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.PICK) {
    // Pick
    if (contents.pick == null) {
      return (<></>);
    }
    backgroundColor = '#9b00ce';
    const [
      powerballOddEvenPick,
      powerballUnderOverPick,
      sumOddEvenPick,
      sumUnderOverPick,
      sumHighLowPick,
    ] = contents.pick.split('|');
    preparedCode = (
      <>
        <div className='chatting-system-message__pick'>
          <div>
            <div className={`chatting-system-message__pick__powerballOddEvenPick ${
              ((pick) => {
                switch (pick) {
                  case '홀':
                    return 'blue';
                  case '짝':
                    return 'red';
                  default:
                    return '';
                }
              })(powerballOddEvenPick)
            }`}>
              {powerballOddEvenPick}
            </div>
            <div className={`chatting-system-message__pick__powerballUnderOverPick ${
              ((pick) => {
                switch (pick) {
                  case '언더':
                    return 'blue';
                  case '오버':
                    return 'red';
                  default:
                    return '';
                }
              })(powerballUnderOverPick)
            }`}>
              {powerballUnderOverPick.substring(0, 1)}
            </div>
          </div>
          <div>
            <div className={`chatting-system-message__pick__sumOddEvenPick ${
              ((pick) => {
                switch (pick) {
                  case '홀':
                    return 'blue';
                  case '짝':
                    return 'red';
                  default:
                    return '';
                }
              })(sumOddEvenPick)
            }`}>
              {sumOddEvenPick}
            </div>
            <div className={`chatting-system-message__pick__sumUnderOverPick ${
              ((pick) => {
                switch (pick) {
                  case '언더':
                    return 'blue';
                  case '오버':
                    return 'red';
                  default:
                    return '';
                }
              })(sumUnderOverPick)
            }`}>
              {sumUnderOverPick.substring(0, 1)}
            </div>
          </div>
          <div className={`chatting-system-message__pick__sumHighLowPick-${
              ((pick) => {
                switch (pick) {
                  case '대':
                    return 'high';
                  case '중':
                    return 'middle';
                  case '소':
                    return 'low';
                  default:
                    return 'none';
                }
              })(sumHighLowPick)
            }`}>
            {sumHighLowPick}
          </div>
        </div>
        {
          powerballOddEvenPick !== '' || powerballUnderOverPick !== ''
            ? (
              <div
                className="chatting-system-message"
                style={{
                  backgroundColor: (() => {
                    let color = '#9b00ce';

                    switch (powerballOddEvenPick) {
                      case '홀':
                        color = 'rgb(18, 101, 205)';
                        break;
                      case '짝':
                        color = 'rgb(205, 18, 18)';
                    }

                    return color;
                  })(),
                }}
              >
                방장 {userDetail?.nickname}님이 <b>[파워볼] {[
                  powerballOddEvenPick, powerballUnderOverPick
                ].filter((v) => v !== '').join(', ')}</b>을(를) 선택하셨습니다.
              </div>
            )
            : null
        }
        {
          sumOddEvenPick !== '' || sumUnderOverPick !== '' || sumHighLowPick !== ''
            ? (
              <div
                className="chatting-system-message"
                style={{
                  backgroundColor: (() => {
                    let color = '#9b00ce';

                    switch (sumOddEvenPick) {
                      case '홀':
                        color = 'rgb(18, 101, 205)';
                        break;
                      case '짝':
                        color = 'rgb(205, 18, 18)';
                    }

                    return color;
                  })(),
                }}
              >
                방장 {userDetail?.nickname}님이 <b>[숫자합] {[
                  sumOddEvenPick, sumUnderOverPick, sumHighLowPick
                ].filter((v) => v !== '').join(', ')}</b>을(를) 선택하셨습니다.
              </div>
            )
            : null
        }
      </>
    );
  } else if (contents.systemMessageType === SystemMessageType.PICK_RESULT) {
    // Generated Result
    if (contents.fullRound == null) {
      return <></>;
    }

    const roundDate = contents.fullRound.split('|')[0].split('-');
    const pickText = contents.pick as string;
    const pickTextUnits = pickText.split('|');
    preparedCode = (
      <>
        <div
          className="chatting-system-message"
          style={{
            backgroundColor: (() => {
              let color = '#000000';

              switch (pickTextUnits[1]) {
                case '홀':
                  color = 'rgb(18, 101, 205)';
                  break;
                case '짝':
                  color = 'rgb(205, 18, 18)';
              }

              return color;
            })(),
          }}
        >
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{contents.fullRound.split('|')[1]}회]
          </span> 파워볼 결과 
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{pickTextUnits[0]}][{pickTextUnits[1]}][{pickTextUnits[2]}]
          </span>
        </div>
        <div
          className="chatting-system-message"
          style={{
            backgroundColor: (() => {
              let color = '#000000';

              switch (pickTextUnits[4]) {
                case '홀':
                  color = 'rgb(18, 101, 205)';
                  break;
                case '짝':
                  color = 'rgb(205, 18, 18)';
              }

              return color;
            })(),
          }}
        >
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{contents.fullRound.split('|')[1]}회]
          </span> 숫자합 결과 
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{pickTextUnits[3]}][{pickTextUnits[4]}][{pickTextUnits[5]}][{pickTextUnits[6]}]
          </span>
        </div>
      </>
    )
    code = (<></>);
  } else if (contents.systemMessageType === SystemMessageType.INCHAT_NOTICE) {
    backgroundColor = '#00000000';
    code = (<div dangerouslySetInnerHTML={{ __html: inchatNoticeContents }}></div>);
  }

  return (
    <>
      {preparedCode}
      <div
        className="chatting-system-message"
        style={{ backgroundColor, }}
      >
        {code}
      </div>
    </>
  );
}

export default SystemMessage;